import styled from "styled-components";
import { colors } from "globalStyles";

export const Wrapper = styled.div`
  padding: 24px 0;

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: ${colors.DARK_GRAY};
    margin-bottom: 16px;
  }

  .admin-growth__error,
  .admin-growth__empty {
    font-size: 14px;
    font-weight: normal;
    color: ${colors.MEDIUM_GRAY};
    padding: 24px 0;
  }
`;

export const BackLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: 13px;
  color: ${colors.SILKBLUE};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
`;

export const MetricsGrid = styled(Grid)`
  margin-bottom: 24px;
`;

export const Card = styled.div`
  background: ${colors.WHITE};
  border: 1px solid ${colors.LIGHT_GRAY};
  border-radius: 8px;
  padding: 20px;
`;

export const Metric = styled.div`
  font-size: 28px;
  font-weight: bold;
  color: ${colors.DARK_GRAY};
  line-height: 1.1;
`;

export const MetricLabel = styled.div`
  font-size: 13px;
  font-weight: bold;
  color: ${colors.MEDIUM_GRAY};
`;

export const Section = styled.div`
  margin-top: 32px;

  h2 {
    font-size: 16px;
    font-weight: bold;
    color: ${colors.DARK_GRAY};
    margin-bottom: 12px;
  }
`;

export const BreakdownRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid ${colors.LIGHT_GRAY};
  font-size: 14px;
`;

export const BreakdownLabel = styled.span`
  color: ${colors.MEDIUM_GRAY};
`;

export const BreakdownValue = styled.span`
  color: ${colors.DARK_GRAY};
  font-weight: bold;
`;

export const SharesLink = styled.button`
  display: inline-block;
  margin-top: 24px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  color: ${colors.SILKBLUE};
  text-decoration: none;
`;
